import { trackClick } from '../lib/analytics';
import React from 'react';

function CustomerPortal() {
  return (
    <section id="customer-portal" className="bg-gray-50 dark:bg-gray-800">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h2 className="mb-4 text-4xl tracking-tight font-extrabold leading-tight text-gray-900 dark:text-white">
            Customer Portal
          </h2>
          <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
            Access your account, manage projects, view invoices, and track service requests all in one place.
          </p>
          <p className="mb-6 text-sm text-gray-600 dark:text-gray-300">
          </p>
          <a
            href="https://dashboard.sdsdeliver.io/"
            onClick={() => trackClick('Access Portal', 'customer_portal', 'https://dashboard.sdsdeliver.io/')}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-center text-white rounded-lg bg-gradient-to-r from-accent-500 to-accent-700 hover:from-accent-600 hover:to-accent-800 focus:ring-4 focus:outline-none focus:ring-accent-300 dark:focus:ring-accent-900 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Access Portal
            <svg
              className="w-5 h-5 ml-2 -mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </a>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-3">
          <div className="p-6 bg-white rounded-lg shadow dark:bg-gray-900">
            <div className="flex items-center justify-center w-10 h-10 mb-4 rounded-full bg-accent-100 lg:h-12 lg:w-12 dark:bg-accent-900">
              <svg
                className="w-5 h-5 text-accent-600 lg:w-6 lg:h-6 dark:text-accent-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
                <path
                  fillRule="evenodd"
                  d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-bold dark:text-white">Project Management</h3>
            <p className="text-gray-500 dark:text-gray-400">
              Track your projects, milestones, and deliverables in real-time.
            </p>
          </div>

          <div className="p-6 bg-white rounded-lg shadow dark:bg-gray-900">
            <div className="flex items-center justify-center w-10 h-10 mb-4 rounded-full bg-accent-100 lg:h-12 lg:w-12 dark:bg-accent-900">
              <svg
                className="w-5 h-5 text-accent-600 lg:w-6 lg:h-6 dark:text-accent-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"></path>
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-bold dark:text-white">Billing & Invoices</h3>
            <p className="text-gray-500 dark:text-gray-400">
              View and download invoices, manage payment methods, and track expenses.
            </p>
          </div>

          <div className="p-6 bg-white rounded-lg shadow dark:bg-gray-900">
            <div className="flex items-center justify-center w-10 h-10 mb-4 rounded-full bg-accent-100 lg:h-12 lg:w-12 dark:bg-accent-900">
              <svg
                className="w-5 h-5 text-accent-600 lg:w-6 lg:h-6 dark:text-accent-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-bold dark:text-white">Support Tickets</h3>
            <p className="text-gray-500 dark:text-gray-400">
              Submit and track support requests with our dedicated team.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CustomerPortal;
